<template>
  <body id="app">
    <b-container fluid>
      <FeaturedBuyersSearching/>
    </b-container>

    <component :is="'style'" lang="css" v-text="themeCSS"></component>
  </body>
</template>

<script>
import Vue from "vue"

import "@/filters.js"

import BootstrapVue from "bootstrap-vue"
Vue.use(BootstrapVue)

Vue.prototype.$ = require('jquery')

Vue.config.productionTip = false

// Global components
import SectionLoader from "@/components/loaders/SectionText.vue"
Vue.component("VSectionLoader", SectionLoader)

import FeaturedBuyersSearching from "@/components/generic/FeaturedBuyersSearching"
import store from "@/store/index"
import {mapGetters} from 'vuex'

export default {
  name: "BuysideFeaturedBuyersSearching",
  store,
  components: {
    FeaturedBuyersSearching
  },
  computed: {
    ...mapGetters('config', ['themeCSS']),
  },
  props: {
    address: {
      type: String,
      required: true
    },
    city: {
      type: String,
      required: true
    },
    state: {
      type: String,
      required: true
    },
    zipcode: {
      type: String,
      required: true
    },
  },
  async created() {
    this.$options.JQuery = require('jquery')

    this.$store.commit('config/loadingConfig', false)

    const addressObj = {
      address1: this.address,
      city: this.city,
      state: this.state,
      zipcode: this.zipcode
    };
    this.$store.commit('listing/setAddress', addressObj)

    try {
      const response = await this.$store.dispatch("listings/getListing", {
        address: addressObj
      })
      this.$store.commit("listings/setListing", response)

      this.$store.dispatch("buyers/getBloopData", {
        limit: 100,
        offset: 0,
        bedroom: this.$store.state.listings.beds > 0 ? this.$store.state.listings.beds : 0,
        house_price: this.$store.state.listings.estimate
      })
      .then   ( response  => this.$store.commit('buyers/setBloopObj', response) )
      .catch  ( er        => console.error(er) )
      .finally( ()        => this.$store.commit('buyers/loadingBloopObj', false) )
    }
    catch(er) {
      console.error(er)
    }
    finally {
      this.$store.commit("listings/loadingListing", false)
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/custom.scss";
#app {
  //font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
